import { formatToLocaleString } from "@/functions/numbers";
import AbstractShape from "@/Models/Shapes/AbstractShape";
import { PreviewShapeFactory } from "@/Models/Shapes/PreviewShapeFactory";

export default {
	namespaced: true,
	getters: {
		getInstance: ( state, getters, rootState, { measurements, uploadAsModel } ): AbstractShape => {
			return ( new PreviewShapeFactory() ).get( {
				shape: 'dxf',
				dimensions: measurements.dimensions,
				modifiers: measurements.modifiers,
				model: uploadAsModel
			} );
		},
		cutoutPrimitives: (): object => {
			return {};
		},
		getCutoutArea: (): number => {
			return 0;
		},
		isCenteredShape: (): boolean => false,
		getArea: (): object => {
			return {};
		},
		dimensionPreview: ( state, getters, rootState, rootGetters ): string => {
			if( getters.getInstance.model === null ) {
				return '';
			}

			const width = getters.getInstance.getWidth().in_cm();
			const height = getters.getInstance.getLength().in_cm();

			return `${formatToLocaleString(height)}cm × ${formatToLocaleString(width)}cm`;
		},
	},
};
